import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import React, { Component } from 'react';
import Loader from 'react-loader-spinner';

class ContactForm extends Component {
  state = {
    firstName: '',
    email: '',
    subject: '',
    lastName: '',
    message: '',
    error: {},
    loading: false,
  };

  changeHandler = (e) => {
    const error = this.state.error;
    error[e.target.name] = '';

    this.setState({
      [e.target.name]: e.target.value,
      error,
    });
  };

  validateInfo = () => {
    let isValid = true;
    const { firstName, email, subject, lastName, message, error } = this.state;

    if (firstName === '') {
      isValid = false;
      error.firstName = 'Please enter your first name';
    }

    if (email === '') {
      isValid = false;
      error.email = 'Please enter your email';
    }

    if (subject === '') {
      isValid = false;
      error.subject = 'Please enter your subject';
    }

    if (lastName === '') {
      isValid = false;
      error.lastName = 'Please enter your last name';
    }

    if (message === '') {
      isValid = false;
      error.message = 'Please enter your message';
    }

    if (!isValid) {
      this.setState({
        error,
      });

      return isValid;
    }

    return isValid;
  };

  submitHandler = (e) => {
    e.preventDefault();
    const isValid = this.validateInfo();

    if (isValid) {
      this.setState({ loading: true });

      emailjs
        .sendForm(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          e.target,
          process.env.REACT_APP_EMAILJS_USER_ID
        )
        .then(
          () => {
            toast.success('Message sent. We will get back to you, soon!');

            this.setState({ loading: false });

            this.setState({
              firstName: '',
              lastName: '',
              message: '',
              email: '',
              subject: '',
              error: {},
              loading: false,
            });
          },
          () => {
            this.setState({ loading: false });
            toast.error('Failed to send the message. Try again.');
          }
        );
    }
  };

  render() {
    const { firstName, email, subject, lastName, message, error, loading } =
      this.state;

    return (
      <form onSubmit={this.submitHandler} className="form">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="form-field">
              <input
                type="text"
                name="toName"
                defaultValue="LHCF INFO"
                hidden
              />
              <input
                value={firstName}
                onChange={this.changeHandler}
                type="text"
                name="firstName"
                placeholder="First Name"
              />
              <p>{error.firstName ? error.firstName : ''}</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="form-field">
              <input
                value={lastName}
                onChange={this.changeHandler}
                type="text"
                name="lastName"
                placeholder="Last Name"
              />
              <p>{error.lastName ? error.lastName : ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <input
                onChange={this.changeHandler}
                value={email}
                type="email"
                name="email"
                placeholder="Email"
              />
              <p>{error.email ? error.email : ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <input
                onChange={this.changeHandler}
                value={subject}
                type="text"
                name="subject"
                placeholder="Subject"
              />
              <p>{error.subject ? error.subject : ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <textarea
                onChange={this.changeHandler}
                name="message"
                placeholder="Message"
                value={message}
              ></textarea>
              <p>{error.message ? error.message : ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-submit">
              {!loading ? (
                <button type="submit" className="theme-btn" disabled>
                  COMING SOON
                </button>
              ) : (
                <button className="theme-btn" disabled>
                  <Loader type="Bars" color="#FFFFFF" height={20} width={30} />
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ContactForm;
